import React, { useState, useContext, createContext } from "react";
import { ProviderServices } from "../services/Provider_Services";
// ** Hooks Imports
import { useClientCity } from "./useClientCity";

// ** Utils Imports
const providersContext = createContext();

export function ProviderProviders({ children }) {
  const providers = useProviderProviders();
  return (
    <providersContext.Provider value={providers}>
      {children}
    </providersContext.Provider>
  );
}

export const useProviders = () => {
  return useContext(providersContext);
};

function useProviderProviders() {
  // ** Hooks
  const { clientCity } = useClientCity();
  // ** State
  const [providers, setProviders] = useState({
    items: [],
    loading: true,
    error: false,
    nextPage: null
  });

  // Get All
  const getAllProviders = () => {
    setProviders((prev) => ({ ...prev, loading: true }));
    ProviderServices.getAll()
      .then((res) => {
        const { data } = res;
        if (Array.isArray(data?.data)) {
          setProviders((prev) => ({
            ...prev,
            items: [...data?.data],
            nextPage: data.links.next
          }));
        }
      })
      .catch((error) => {
        setProviders((prev) => ({ ...prev, error: true }));
      })
      .finally(() => {
        setProviders((prev) => ({ ...prev, loading: false }));
      });
  };
  // ** Get Providers Next Page
  const getNextPageProviders = (url) => {
    if (url) {
      ProviderServices.getNextPage(url)
        .then((res) => {
          const { data } = res;
          if (Array.isArray(data?.data)) {
            // const newProviders = providers.items;
            // newProviders.push(...data?.data);
            setProviders((prev) => ({
              ...prev,
              items: [...prev.items, ...data?.data],
              nextPage: data.links.next
            }));
          }
        })
        .catch((error) => {})
        .finally(() => {});
    }
  };

  // ** Get Provider By ID
  const getMealsProvider = (id) => {
    return new Promise((resolve, reject) => {
      if (id) {
        ProviderServices.getMealsProvider(id)
          .then((result) => {
            const { data } = result;
            if (Array.isArray(data?.data)) resolve({ images: data?.data });
          })
          .catch((error) => {
            reject({ images: [], errors: "Error" });
          });
      } else {
        resolve({ images: [] });
      }
    });
  };

  // ** Any Next Page Provider
  const getProvidersNextPage = (url) => {
    return new Promise((resolve, reject) => {
      ProviderServices.getNextPage(url)
        .then((result) => {
          const { data } = result;
          if (Array.isArray(data?.data)) {
            resolve({
              items: [...data?.data],
              next: data?.links?.next,
              status: true
            });
          } else {
            resolve({ status: true, next: null, items: [] });
          }
        })
        .catch((error) => {
          reject({ status: false, error: error, next: null, items: [] });
        });
    });
  };
  // ** Get Provider By Filter
  const getFilterProvider = ({ filterData,city_id }) => {
    return new Promise((resolve, reject) => {
      ProviderServices.getFilterProvider({ filter: filterData,city_id })
        .then((result) => {
          const { data } = result;
          if (Array.isArray(data?.data)) {
            resolve({
              items: [...data?.data],
              next: data?.links?.next,
              status: true
            });
          } else {
            resolve({ status: false, next: null });
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  // Search Providers
  const searchProviders = ({ name = "" }) => {
    return new Promise((resolve, reject) => {
      ProviderServices.searchProvider({ name: name, city_id: clientCity.id })
        .then((result) => {
          const { data } = result;
          if (Array.isArray(data?.data)) {
            resolve({
              items: [...data?.data],
              next: data?.links?.next,
              status: true
            });
          } else {
            resolve({ status: true, next: null, items: [] });
          }
        })
        .catch((error) => {
          reject({ status: false, error: error, next: null, items: [] });
        });
    });
  };

  // Return State
  return {
    providers,
    getAllProviders,
    getNextPageProviders,
    getMealsProvider,
    getFilterProvider,
    searchProviders,
    getProvidersNextPage
  };
}
